import { EWsSessionActionTypes } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

/**
 * Установить регистрацию сессии по WS
 */
export const setWsRegistration = actionGenerator<EWsSessionActionTypes.SetWsRegistration, string>(
  EWsSessionActionTypes.SetWsRegistration,
);
